module.exports = __webpack_public_path__ + "img/default_exp.55a26739.jpg";